import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    withComponentInputBinding,
    withPreloading,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

import { routes } from './app.routes';
import { provideNumericInputGuard } from './core/directives/numeric-input.guard';
import { siteHeaderInterceptor } from './core/http/site-header.interceptor';
import { provideCkHttp } from './core/http/http.providers';
import { provideI18n } from './core/i18n/i18n.providers';
import { SiteSettingsStore } from './core/services/site-settings.store';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withComponentInputBinding(), withPreloading(PreloadAllModules)),
        provideHttpClient(withFetch(), withInterceptors([siteHeaderInterceptor])),
        provideAnimationsAsync(),
        importProvidersFrom(NgbModule, NgxDaterangepickerMd.forRoot()),
        provideI18n(),
        provideCkHttp(),
        provideNumericInputGuard(),
        provideAppInitializer(() => {
            inject(SiteSettingsStore).refresh().subscribe();
        }),
        DatePipe,
    ],
};
